/* eslint-disable no-loop-func */
/* eslint-disable no-param-reassign */
import { clone, getDateObjectFromString } from '@xto10x/core/lib/app.utils';
import { OBJECTIVE_VISIBILITY_TYPES } from 'utils/constants';

const updateKrsVisibility = (key_results, privacy_details) =>
  key_results.map(kr => {
    if (
      !kr.dependency_objective &&
      kr.privacy_details?.type === OBJECTIVE_VISIBILITY_TYPES.public
    )
      return {
        ...kr,
        key_results: updateKrsVisibility(kr.key_results, privacy_details),
        privacy_details
      };
    return kr;
  });

const visibilityUtils = {
  updateObjectiveVisibilityUsingPath: (
    objectivesList,
    objective,
    rootObjectiveIndex,
    path
  ) => {
    if (!path || !path.length) return;
    let index = parseInt(rootObjectiveIndex.replace('root_objective_', ''), 10);
    let currentObjective = objectivesList[index];
    if (path.length === 1) {
      const obj = {
        ...objective,
        alignment_of: currentObjective.alignment_of,
        isOpen: currentObjective.isOpen,
        dependency_objective: currentObjective.dependency_objective,
        key_results: updateKrsVisibility(
          currentObjective.key_results,
          objective.privacy_details
        ),
        key_results_count: currentObjective.key_results_count,
        matching_objectives_in_subtree:
          currentObjective.matching_objectives_in_subtree
      };
      objectivesList.splice(index, 1, obj);
    }

    let parent = currentObjective;
    let isKr = false;

    for (let i = 1; i <= path.length - 1; i += 1) {
      parent = currentObjective;
      isKr =
        parent.key_results.filter(
          key_result => key_result.objective_id === path[i]
        ).length > 0;
      if (isKr) {
        index = parent.key_results.findIndex(
          item => item.objective_id === path[i]
        );
        currentObjective = currentObjective.key_results[index];
      }
    }
    if (isKr) {
      const obj = {
        ...objective,
        alignment_of: currentObjective.alignment_of,
        isOpen: currentObjective.isOpen,
        dependency_objective: currentObjective.dependency_objective,
        matching_objectives_in_subtree:
          currentObjective.matching_objectives_in_subtree,
        key_results: updateKrsVisibility(
          currentObjective.key_results,
          objective.privacy_details
        ),
        key_results_count: currentObjective.key_results_count
      };
      if (obj.dependency_objective) {
        obj.dependent_objectives_count = 0;
      }
      parent.key_results.splice(index, 1, obj);
      parent.kr_due_date_exceeded = false;
      //  check if krs due date exceed parent's due date
      if (
        parent.key_results.findIndex(
          kr =>
            kr.due_date &&
            parent.due_date &&
            getDateObjectFromString(kr.due_date).getTime() >
              getDateObjectFromString(parent.due_date).getTime()
        ) > -1
      ) {
        parent.kr_due_date_exceeded = true; // add marker to parent's due date
      }
    }
  },

  updateObjectiveVisibilityUsingPaths: (
    objectivesList,
    objective,
    rootObjectiveIndexes
  ) => {
    if (!rootObjectiveIndexes) return objectivesList;
    Object.keys(rootObjectiveIndexes).forEach(rootObjectiveIndex =>
      visibilityUtils.updateObjectiveVisibilityUsingPath(
        objectivesList,
        objective,
        rootObjectiveIndex,
        rootObjectiveIndexes[rootObjectiveIndex]
      )
    );
    return clone(objectivesList, []);
  }
};

export default visibilityUtils;

export const updateObjectiveVisibilityUsingPaths = (
  objectiveList,
  objective,
  paths
) =>
  visibilityUtils.updateObjectiveVisibilityUsingPaths(
    objectiveList,
    objective,
    paths
  );
